import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../../components/button/ButtonPrimary";
import Draggable from "react-draggable";
import { useIsMobile } from "../../../functions/isMobile";

const DeleteSharedBookmark = (props) => {
  const isMobile = useIsMobile();

  const { deletePopup, setDeletePopup, email, id, deleteSharedUser } = props;
  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const divRef = useRef(null);

  const handleDelete = () => {
    deleteSharedUser(id, email);
    setDeletePopup(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleDelete();
    }
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  useEffect(() => {
    if (divRef.current) {
      divRef.current.focus();
    }
  }, []);

  return (
    deletePopup && (
      <>
        <div className="new-bookmark-delete-popup-bg-dark" />
        <Draggable
          position={{
            x: Number(position.marginLeft),
            y: Number(position.marginTop),
          }}
          onDrag={handleDrag}
          cancel={isMobile ? ".new-bookmark-delete-popup" : null}
        >
          <div className="new-bookmark-delete-popup">
            <div
              ref={divRef}
              onKeyDown={(e) => handleKeyDown(e)}
              className="popup-card"
            >
              <CloseIcon
                className="cross"
                onClick={() => setDeletePopup(false)}
              />

              <p className="popup-title">
                Are you sure you want to remove {email} from this collection?
              </p>
              <div className="save-actions">
                <div />
                <div className="flex">
                  <ButtonPrimary
                    text="Cancel"
                    onClick={() => setDeletePopup(false)}
                    className="mr-2 grey"
                    outline
                  />
                  <ButtonPrimary text="Confirm" onClick={handleDelete} />
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </>
    )
  );
};

export default DeleteSharedBookmark;
